<div class="four-o-one-page">
<img class="four-o-one-img" src="../../../../assets/group-4_401@1x.png" />
<button (click)="goBack()" class="four-o-one-button">Go Back</button>
</div>